import {Injectable, inject} from "@angular/core";
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {Observable, takeUntil} from "rxjs";
import {HttpRequestTrackerService} from "../services/http-request-tracker.service";

// Préfixes URL exclus de l'annulation lors des navigations
// (endpoints long-lived / cross-vue : messagerie temps réel, notifications, session utilisateur)
// ⚠️ Doit rester synchronisé avec les exclusions de HttpRequestInterceptor (même politique,
// appliquée aux deux takeUntil de la chaîne — un seul des deux suffit à annuler la requête).
const CANCEL_EXCLUDE_PATTERNS = [
    'api/messagerie/',
    'api/extras/notifications',
    'api/users/me',
];

@Injectable()
export class HttpCancelInterceptor implements HttpInterceptor {
    private httpCancelService = inject(HttpRequestTrackerService);

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        const isApiRequest = req.url.startsWith('api');
        const isExcluded = CANCEL_EXCLUDE_PATTERNS.some(pattern => req.url.includes(pattern))
            || this.httpCancelService.estHorsAnnulation(req);

        if (isApiRequest && !isExcluded && req.method !== 'OPTIONS') {
            return next.handle(req).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()));
        }
        return next.handle(req);
    }
}

export const httpCancelInterceptorProviders = [
    {provide: HTTP_INTERCEPTORS, useClass: HttpCancelInterceptor, multi: true}
];